export default __webpack_public_path__ + "static/media/small.ccfa1374.jpg";